import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { KEYS } from 'src/app/constants/keys';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { CommonService } from 'src/app/services/common-service/common.service';
import { SessionTimerService } from 'src/app/services/session-timer.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private commonService: CommonService,
    private sessionTimer: SessionTimerService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.authService.isLoggedIn() && !this.authService.isAdminLogin()) {
      return true;
    } else {
      let loginHistoryId = sessionStorage.getItem(KEYS.loginHistoryId);
      const sessionDuration = this.sessionTimer.stopTimer();
      this.commonService.updateSessionAutoLogout(loginHistoryId, 1).subscribe(data => { }, error => { })
      this.authService.redirectToLogin();
      return false;
    }
  }
}
